// obituary Reducer

const obituaryDefaultState = {
    id: '',
    idBeneficiaire: '',
    displayObituary: "0",
    newspapers: '',
    obituaryText: '',
    listToInform: []
};

export default (state = obituaryDefaultState, action) => {
    switch (action.type) {
        case 'SET_OBITUARY':
            return {
                ...state,
                id: action.data.id,
                idBeneficiaire: action.data.idBeneficiaire,
                displayObituary: action.data.displayObituary,
                newspapers: action.data.newspapers,
                obituaryText: action.data.obituaryText
            };

        case 'GET_OBITUARY':
            return {
                ...state,
                id: action.data.id,
                idBeneficiaire: action.data.idBeneficiaire,
                displayObituary: !!+action.data.displayObituary,
                newspapers: action.data.newspapers,
                obituaryText: action.data.obituaryText
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/obituary.js